import * as t from "io-ts";

export const InterestInCredit = t.union([t.literal("yes"), t.literal("no")]);

export type InterestInCredit = "yes" | "no";
